export class Run {
    courseId: string | null = null;
    courseName: string | null = null;
    ninjaId: string | null = null;
    ninjaName: string | null = null;

    aggregrateTimeSpent: number[] = [];
    submissionsRecieved: number[] = [];
    fallCounts: number[] = [];

    fellOn: number | null = null;
    totalTime: number | null = null;

    flagForReview: boolean | null = null;
    lastUpdated: Date | null = null;
}
